import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

import { Web3Provider } from '@ethersproject/providers';

import { createWeb3Modal } from '@web3modal/wagmi/react'
import { defaultWagmiConfig } from '@web3modal/wagmi/react/config'

import { WagmiProvider } from 'wagmi'
import { arbitrum, base, avalanche, bsc, mainnet, optimism, polygon, fantom, zkSync, opBNB, dogechain } from 'wagmi/chains'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Web3ReactProvider } from "@web3-react/core";

import './components/common/asset/scss/style.scss';
import 'antd/dist/antd.css';
import Header from './components/common/header';
import MenuSideBar from './components/common/menuSideBar';
import Home from './components/home';
import LaunchPad from './components/launchpad';
import LaunchpadDetail from './components/launchpadDetail';
import Upcoming from './components/launchpad/upcoming';
import Opening from './components/launchpad/opening';
import Completed from './components/launchpad/completed';
import Joined from './components/launchpad/joined';
import Claimable from './components/launchpad/claimable';
import Stake from './components/stake';
import Airdrop from './components/airdrop';
import DetailAirdrop from './components/airdrop/detailAirdrop';
import Ino from './components/ino';
import InoDetail from './components/ino/inoDetail';
import UpcomingIno from './components/ino/upcoming';
import EndedIno from './components/ino/ended';
import OpeningIno from './components/ino/opening';
import { useSelector, useDispatch } from 'react-redux';
import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import UpcomingAirdrop from './components/airdrop/upcoming';
import OpeningAirdrop from './components/airdrop/opening';
import CompletedAirdrop from './components/airdrop/completed';
import GameHub from './components/gameHub';
import GameHubDetail from './components/gameHub/detailGamehub';
import Catalog from './components/gameHub/catalogGamehub';
import Terms from './components/terms';
import Privacy from './components/privacy';
import CookiesPage from './components/cookies';


function App() {
    const [toggleSidebar, setToggleSidebar] = useState();
    const [openMenuSP, setOpenMenuSP] = useState(false);


    const isToggleSidebar = (isToggleSidebar) => {
        setToggleSidebar(isToggleSidebar);
    };
    const openMenuSp = (value) => {
        setOpenMenuSP(value);
    };

    function getLibrary(provider) {
        const library = new Web3Provider(provider);
        library.pollingInterval = 15000;
        return library;
    }

    // start wagmi

    // 0. Setup queryClient
    const queryClient = new QueryClient()

    // 1. Get projectId at https://cloud.walletconnect.com
    const projectId = '90442772461be13996b4d4766e81fd8f'

    // 2. Create wagmiConfig
    const metadata = {
        name: 'Web3Modal',
        description: 'Web3Modal BSCS',
        url: 'https://web3modal.com', // origin must match your domain & subdomain
        icons: ['https://avatars.githubusercontent.com/u/37784886']
    };

    const kaiaMainnet = {
        id: 8217,
        name: "Kaia",
        nativeCurrency: {
            name: "Kaia",
            symbol: "KAIA",
            decimals: 18,
        },
        rpcUrls: {
            default: { http: ["https://public-en.node.kaia.io"] },
            public: { http: ["https://public-en.node.kaia.io"] },
        },
        blockExplorers: {
            default: { name: "KaiaScan", url: "https://kaiascan.io/" },
        },
    };

    const avaxMainnet = {
        ...avalanche,
        rpcUrls: {
            ...avalanche.rpcUrls,
            default: {
                http: ['https://ava-mainnet.public.blastapi.io/ext/bc/C/rpc'], // RPC tùy chỉnh
            },
        },
    }




    const chains = [arbitrum, base, avaxMainnet, bsc, mainnet, optimism, polygon, fantom, zkSync, opBNB, dogechain, kaiaMainnet]

    const config = defaultWagmiConfig({
        chains, // required
        projectId, // required
        metadata, // required
        enableInjected: true, // Optional - true by default
        enableWalletConnect: true, // Optional - true by default
        enableEIP6963: true, // Optional - true by default
        enableCoinbase: false, // Optional - true by default
    })

    // 3. Create modal
    createWeb3Modal({
        wagmiConfig: config,
        projectId,
        enableAnalytics: true // Optional - defaults to your Cloud configuration
    })

    // over wagmi

    return (
        <Web3ReactProvider getLibrary={getLibrary}>
            {/* <Web3ProviderNetwork getLibrary={getLibrary}> */}
            <WagmiProvider config={config}>
                <QueryClientProvider client={queryClient}>
                    <Router>
                        <div className={`p-app ${toggleSidebar === true ? 'is-toggle' : ''}`}>
                            <Header openMenuSp={openMenuSp} />
                            <MenuSideBar openMenuSp={openMenuSP} isToggleSidebar={isToggleSidebar} />
                            <ReactNotifications />
                            <div className="l-main">
                                <Routes>
                                    <Route exact path="/" element={<Home />} />
                                    <Route path="/launchpad" element={<LaunchPad />}>
                                        <Route path="/launchpad" element={<Navigate replace to="/launchpad/upcoming" />} />
                                        <Route path="/launchpad/upcoming" element={<Upcoming />} />
                                        <Route path="/launchpad/opening" element={<Opening />} />
                                        <Route path="/launchpad/completed" element={<Completed />} />
                                        <Route path="/launchpad/joined" element={<Joined />} />
                                        <Route path="/launchpad/claimable" element={<Claimable />} />
                                        <Route exact path="/launchpad/upcoming/:handle" element={<LaunchpadDetail />} />
                                        <Route exact path="/launchpad/opening/:handle" element={<LaunchpadDetail />} />
                                        <Route exact path="/launchpad/completed/:handle" element={<LaunchpadDetail />} />
                                        <Route exact path="/launchpad/joined/:handle" element={<LaunchpadDetail />} />
                                        <Route exact path="/launchpad/claimable/:handle" element={<LaunchpadDetail />} />
                                        <Route exact path="/launchpad-detail/:handle" element={<LaunchpadDetail />} />
                                    </Route>

                                    <Route path="/ino" element={<Ino />} >
                                        <Route path="/ino" element={<Navigate replace to="/ino/upcoming" />} />
                                        <Route path="/ino/upcoming" element={<UpcomingIno />} />
                                        <Route path="/ino/opening" element={<OpeningIno />} />
                                        <Route path="/ino/ended" element={<EndedIno />} />
                                        <Route path="/ino/upcoming/:handle" element={<InoDetail />} />
                                        <Route path="/ino/opening/:handle" element={<InoDetail />} />
                                        <Route path="/ino/ended/:handle" element={<InoDetail />} />
                                        <Route path="/ino/bought/:handle" element={<InoDetail />} />
                                    </Route>
                                    <Route path="/stake" element={<Stake />} />
                                    <Route path="/airdrop" element={<Airdrop />} >
                                        <Route path="/airdrop" element={<Navigate replace to="/airdrop/upcoming" />} />
                                        <Route path="/airdrop/upcoming" element={<UpcomingAirdrop />} />
                                        <Route path="/airdrop/ongoing" element={<OpeningAirdrop />} />
                                        <Route path="/airdrop/completed" element={<CompletedAirdrop />} />
                                    </Route>
                                    <Route path="/airdrop-detail/:handle" element={<DetailAirdrop />} />
                                    {/* <Route path="/stake" element={<Stake/>} /> */}
                                    <Route path="/gamehub" element={<GameHub />} />
                                    <Route path="/gamehub/catalog/:handle" element={<Catalog />} />
                                    <Route path="/gamehub/:handle" element={<GameHubDetail />} />
                                    <Route path="/terms" element={<Terms />} />
                                    <Route path="/privacy" element={<Privacy />} />
                                    <Route path="/cookies" element={<CookiesPage />} />
                                </Routes>
                            </div>
                            {/* <div className="c-backTop"><img src="../images/backTop.gif" alt="" /></div> */}
                        </div>
                    </Router>
                </QueryClientProvider>
            </WagmiProvider>

            {/* </Web3ProviderNetwork> */}
        </Web3ReactProvider>

    );
}

export default App;
